var root = require('./_root');

/** Built-in value references. */
var Symbol = root.Symbol;

module.exports = Symbol;



//////////////////
// WEBPACK FOOTER
// ./~/victory-zoom-container/~/lodash/_Symbol.js
// module id = ./node_modules/victory-zoom-container/node_modules/lodash/_Symbol.js
// module chunks = 1